import { render, staticRenderFns } from "./daumPostcode.vue?vue&type=template&id=fb492d06&"
import script from "./daumPostcode.vue?vue&type=script&lang=ts&"
export * from "./daumPostcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports